import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { CHATBOT_CHANGE } from "../../Actions/Kiosk/chatbotChangeAction";
import { CHATBOT_RESET } from '../../Actions/Kiosk/chatbotResetAction';
import storeState, { emptyState } from "../../../utils/storeState";
import { storageKeyChatbot } from "../../../model/StorageKeys";

export default function chatbotReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch(action.type) {
    case CHATBOT_CHANGE:
      storeState(storageKeyChatbot, action.payload.chatbot);
      return {
        ...state,
        chatbot: action.payload.chatbot
      }
    case CHATBOT_RESET:
      emptyState(storageKeyChatbot);
      return {
        ...state,
        chatbot: undefined
      }
    default:
      return state;
  }
}
